/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './integration-endpoint-attribute.reducer';

export const IntegrationEndpointAttribute = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const integrationEndpointAttributeList = useAppSelector(state => state.integrationEndpointAttribute.entities);
  const loading = useAppSelector(state => state.integrationEndpointAttribute.loading);
  const totalItems = useAppSelector(state => state.integrationEndpointAttribute.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="integration-endpoint-attribute-heading" data-cy="IntegrationEndpointAttributeHeading">
        <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.home.title">Integration Endpoint Attributes</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/integration-endpoint-attribute/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.home.createLabel">
              Create new Integration Endpoint Attribute
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.integrationEndpointAttribute.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {integrationEndpointAttributeList && integrationEndpointAttributeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('defaultValue')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.defaultValue">Default Value</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('defaultValue')} />
                </th>
                <th className="hand" onClick={sort('example')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.example">Example</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('example')} />
                </th>
                <th className="hand" onClick={sort('mandatory')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.mandatory">Mandatory</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mandatory')} />
                </th>
                <th className="hand" onClick={sort('userSpecific')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.userSpecific">User Specific</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userSpecific')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.coFormat">Co Format</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.ciFormat">Ci Format</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.attributeType">Attribute Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.valueType">Value Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.valueRange">Value Range</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.endpoint">Endpoint</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.parent">Parent</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.tenantAttribute">Tenant Attribute</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {integrationEndpointAttributeList.map((integrationEndpointAttribute, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/integration-endpoint-attribute/${integrationEndpointAttribute.id}`} color="link" size="sm">
                      {integrationEndpointAttribute.id}
                    </Button>
                  </td>
                  <td>{integrationEndpointAttribute.name}</td>
                  <td>{integrationEndpointAttribute.defaultValue}</td>
                  <td>{integrationEndpointAttribute.example}</td>
                  <td>{integrationEndpointAttribute.mandatory ? 'true' : 'false'}</td>
                  <td>{integrationEndpointAttribute.userSpecific ? 'true' : 'false'}</td>
                  <td>{integrationEndpointAttribute.active ? 'true' : 'false'}</td>
                  <td>{integrationEndpointAttribute.cursor}</td>
                  <td>{integrationEndpointAttribute.lastUpdated}</td>
                  <td>{integrationEndpointAttribute.microSec}</td>
                  <td>{integrationEndpointAttribute.timestampEntry}</td>
                  <td>
                    {integrationEndpointAttribute.coFormat ? (
                      <Link to={`/clinical-dictionary/${integrationEndpointAttribute.coFormat.id}`}>
                        {integrationEndpointAttribute.coFormat.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {integrationEndpointAttribute.ciFormat ? (
                      <Link to={`/clinical-dictionary/${integrationEndpointAttribute.ciFormat.id}`}>
                        {integrationEndpointAttribute.ciFormat.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {integrationEndpointAttribute.attributeType ? (
                      <Link to={`/clinical-dictionary/${integrationEndpointAttribute.attributeType.id}`}>
                        {integrationEndpointAttribute.attributeType.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {integrationEndpointAttribute.valueType ? (
                      <Link to={`/clinical-dictionary/${integrationEndpointAttribute.valueType.id}`}>
                        {integrationEndpointAttribute.valueType.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {integrationEndpointAttribute.valueRange ? (
                      <Link to={`/clinical-dictionary/${integrationEndpointAttribute.valueRange.id}`}>
                        {integrationEndpointAttribute.valueRange.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {integrationEndpointAttribute.endpoint ? (
                      <Link to={`/integration-endpoint/${integrationEndpointAttribute.endpoint.id}`}>
                        {integrationEndpointAttribute.endpoint.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {integrationEndpointAttribute.parent ? (
                      <Link to={`/integration-endpoint-attribute/${integrationEndpointAttribute.parent.id}`}>
                        {integrationEndpointAttribute.parent.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {integrationEndpointAttribute.tenantAttribute ? (
                      <Link to={`/tenant-integration-endpoint-attribute/${integrationEndpointAttribute.tenantAttribute.id}`}>
                        {integrationEndpointAttribute.tenantAttribute.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/integration-endpoint-attribute/${integrationEndpointAttribute.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/integration-endpoint-attribute/${integrationEndpointAttribute.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/integration-endpoint-attribute/${integrationEndpointAttribute.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.home.notFound">
                No Integration Endpoint Attributes found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={integrationEndpointAttributeList && integrationEndpointAttributeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default IntegrationEndpointAttribute;
